// 荣峰服务器   测试服务器
//var basicUrl = process.env.NODE_ENV === 'development' ? "http://10.10.11.250:668" : 'https://slczb.sunray365.com:98'
// var basicUrl = 'https://slczb.sunray365.com:88'
var basicUrl = 'https://slczb.sunray365.com:88'
export default basicUrl
export var middleBasicUrl = process.env.NODE_ENV === 'development' ? "http://10.10.11.250:700" : 'https://slczb.sunray365.com:98'
